import {
  Box,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import UserInformationBodyModalStyles from "./UserInformationBodyModal.styles";
import { MdOutlineClose } from "react-icons/md";
import { selectCurrentUser } from "../../../store/slices/user";
import AnimationContent from "../../sharedComponents/AnimationContent";
import loadingAnimation from "../../../assets/lottieFiles/loaderAnimation.json";
import successAnimation from "../../../assets/lottieFiles/successAnimation.json";
import { STATUS_VARIANTS, TIPO_USUARIO_VARIANTS } from "./utils";
import { useSelector } from "react-redux";
import { selectAccessToken } from "../../../store/slices/clients";
import useLogout from "../../../hooks/useLogout";

const UserinformationBodyModal = (props) => {
  const {
    handleClose,
    type,
    saveInformationHandler,
    loading,
    success,
    availableRoutes,
  } = props;

  /*Mostrar el dropdown de rutas */
  const [showRouteDropdown, setShowRouteDropdown] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(0);

  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
  const userInformation = useSelector(selectCurrentUser);
  const classes = UserInformationBodyModalStyles();
  const [currentUserInformation, setCurrentUserInformation] = useState({});
  const [handleEdit, setHandleEdit] = useState(false);
  const accesToken = useSelector(selectAccessToken);
  const [logout] = useLogout();
  const [shouldDisableFields, setshouldDisableFields] = useState(
    type === "view"
  );

  const [errors, setErrors] = useState({
    name: "",
    username: "",
  });

  useEffect(() => {
    if (type && (type === "view" || type === "edit")) {
      setCurrentUserInformation({
        idUser: userInformation.id_user,
        username: userInformation.username,
        name: userInformation.name,
        password: userInformation.password,
        idUserType: userInformation.id_user_type,
        idRoute:
          userInformation.id_user_type === 5 ||
          userInformation.id_user_type === 6
            ? parseInt(userInformation.id_route)
            : 0, // Si no es App Ruta o App Supervisor, idRoute será 0
        status: userInformation.status,
      });

      if (userInformation.id_user_type === 7) {
        setShowCompanyDropdown(true);
      }

      setShowRouteDropdown(
        userInformation.id_user_type === 5 || userInformation.id_user_type === 6
      );
      setSelectedRoute(
        userInformation.id_user_type === 5 || userInformation.id_user_type === 6
          ? parseInt(userInformation.id_route)
          : 0
      );
    } else {
      setCurrentUserInformation({
        idUser: "",
        username: "",
        password: "",
        name: "",
        idUserType: 2,
        idRoute: 0,
        status: 1,
      });
      setShowRouteDropdown(false);
      setSelectedRoute(0);
    }
  }, [type, userInformation]);

  const { username, name, idUserType, password, idRoute, status } =
    currentUserInformation;

  const disableWhenIsNew =
    !username || !name || !password || password.length < 8;

  const disableWhenIsEdit =
    !username || !name || !idUserType || !idRoute || !status;

  const isView = type === "view";

  const [passwordHelperText, setPasswordHelperText] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(null);

  const handleChangeRoute = (e) => {
    const routeId = parseInt(e.target.value);
    setSelectedRoute(routeId);
    setCurrentUserInformation((prevState) => ({
      ...prevState,
      idRoute: routeId,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedState = { ...currentUserInformation, [name]: value };

    let newValue = value;
    let newErrors = { ...errors };

    if (name === "name") {
      newValue = newValue.replace(/[^a-zA-ZÁÉÍÓÚáéíóúñÑ\s]/g, ""); // Solo letras y espacios
      if (!newValue) {
        newErrors[name] = "*Campo obligatorio*";
      } else {
        newErrors[name] = "";
      }
    }

    if (name === "username") {
      newValue = newValue.replace(/[^a-z0-9._-]/g, ""); // Solo caracteres permitidos
      if (!newValue) {
        newErrors[name] = "*Campo obligatorio*";
      } else {
        newErrors[name] = "";
      }
    }

    if (name === "password") {
      if (value.length < 8) {
        setPasswordHelperText("La contraseña debe tener al menos 8 caracteres");
        setIsPasswordValid(false);
      } else {
        setPasswordHelperText("Contraseña válida");
        setIsPasswordValid(true);
      }
    }

    setErrors(newErrors);
    setCurrentUserInformation((prevState) => {
      return {
        ...prevState,
        [name]: newValue,
      };
    });

    if (name === "idUserType") {
      const userType = parseInt(value);

      setShowRouteDropdown(userType === 5 || userType === 6);

      if (userType !== 5 && userType !== 6) {
        updatedState.idRoute = 0;
        setSelectedRoute(0);
      }

      setShowCompanyDropdown(parseInt(value) === 7);
    }
    setCurrentUserInformation(updatedState);
  };

  const handleEditChange = () => {
    setHandleEdit(!handleEdit);
    if (isView) {
      setshouldDisableFields(!shouldDisableFields);
    }
  };

  const RenderUpdateButton = () => {
    return (
      <>
        {isView && !shouldDisableFields && (
          <Button
            className={classes.saveButton}
            type="contained"
            color="primary"
            onClick={() => saveInformationHandler(currentUserInformation)}
          >
            <Typography className={classes.updateInfoBtn}>
              Actualizar
            </Typography>
          </Button>
        )}
      </>
    );
  };

  const isCentered = loading || success;
  return (
    <Box
      className={classes.mainContainer}
      display={isCentered && "flex"}
      alignItems={isCentered && "center"}
      justifyContent={isCentered && "center"}
    >
      {loading ? (
        <Box>
          {success ? (
            <React.Fragment>
              <AnimationContent
                animationFile={success ? successAnimation : loadingAnimation}
              />
              <Typography align="center" variant="subtitle1">
                {type === "new"
                  ? "Usuario Creado con éxito"
                  : "Usuario actualizado con éxito"}
              </Typography>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <AnimationContent
                animationFile={success ? successAnimation : loadingAnimation}
              />
              <Typography align="center" variant="subtitle1">
                {type === "new" ? "Creando usuario" : "Actualizando usuario"}
              </Typography>
              <Typography align="center" variant="subtitle2">
                Por favor, no cierres la pantalla
              </Typography>
            </React.Fragment>
          )}
        </Box>
      ) : (
        <React.Fragment>
          <div className={classes.closeIconContainerMain} onClick={handleClose}>
            <IconButton>
              <MdOutlineClose />
            </IconButton>
          </div>
          <Box className={classes.contentContainer}>
            <Typography className={classes.titleBodyModal}>
              Información del usuario
            </Typography>
            <Typography className={classes.userInfoSubheader}>
              La información puede ser actualizada
            </Typography>

            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  className={classes.inputEnabled}
                >
                  Nombre
                </Typography>
                <TextField
                  disabled={shouldDisableFields}
                  variant="outlined"
                  name="name"
                  onChange={(e) => handleChange(e)}
                  value={name && name.toLowerCase()}
                  inputProps={{ className: classes.input }}
                  className={classes.inputContainer}
                  error={Boolean(errors.name)}
                  helperText={errors.name}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  className={classes.inputEnabled}
                >
                  Usuario
                </Typography>
                <TextField
                  disabled={shouldDisableFields}
                  variant="outlined"
                  name="username"
                  onChange={(e) => handleChange(e)}
                  value={username && username.toLowerCase()}
                  inputProps={{ className: classes.input }}
                  className={classes.inputContainer}
                  error={Boolean(errors.username)}
                  helperText={errors.username}
                />
              </Grid>
              {type === "new" && (
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    className={classes.inputEnabled}
                  >
                    Contraseña
                  </Typography>
                  <TextField
                    disabled={shouldDisableFields}
                    variant="outlined"
                    name="password"
                    onChange={handleChange}
                    value={password || ""}
                    inputProps={{ className: classes.input }}
                    className={classes.inputContainer}
                    helperText={passwordHelperText}
                    error={isPasswordValid === false}
                    FormHelperTextProps={{
                      style: {
                        color: isPasswordValid ? "green" : "red",
                        textAlign: "left",
                      },
                    }}
                  />
                </Grid>
              )}

              <Grid container spacing={0} xs={12}>
                <Grid item xs={6} className={`${classes.inputContainer}`}>
                  <Typography
                    variant="subtitle2"
                    className={classes.inputEnabled}
                  >
                    Tipo de usuario
                  </Typography>

                  <Select
                    disabled={shouldDisableFields}
                    variant="outlined"
                    name="idUserType"
                    value={idUserType ? parseInt(idUserType) : 2}
                    onChange={(e) => handleChange(e)}
                    /* style={{ width: 200 }} */
                    style={{ width: "90%" }}
                  >
                    {TIPO_USUARIO_VARIANTS?.map((tipo) => (
                      <MenuItem key={tipo.id} value={tipo.id}>
                        {tipo.desc.toLowerCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {showRouteDropdown && (
                  <Grid item xs={6} className={classes.inputContainer}>
                    <Typography
                      variant="subtitle2"
                      className={classes.inputEnabled}
                    >
                      Ruta designada
                    </Typography>
                    <Select
                      disabled={shouldDisableFields}
                      variant="outlined"
                      name="idRoute"
                      value={selectedRoute || 0}
                      onChange={handleChangeRoute}
                      style={{ width: "90%" }}
                    >
                      {availableRoutes && availableRoutes.length > 0 ? (
                        availableRoutes.map((route) => (
                          <MenuItem
                            key={parseInt(route.id_route)}
                            value={parseInt(route.id_route)}
                          >
                            {route.description
                              ? route.description.toLowerCase()
                              : "Sin descripción"}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>No hay rutas disponibles</MenuItem>
                      )}
                    </Select>
                  </Grid>
                )}
              </Grid>

              {showCompanyDropdown && (
                <Grid item xs={6} className={classes.inputContainer}>
                  <Typography
                    variant="subtitle2"
                    className={classes.inputEnabled}
                  >
                    Compañía
                  </Typography>
                </Grid>
              )}

              <Grid item xs={6}>
                <Typography
                  variant="subtitle2"
                  className={classes.inputEnabled}
                >
                  Estado
                </Typography>
                <Select
                  disabled={shouldDisableFields}
                  variant="outlined"
                  name="status"
                  value={status !== undefined ? status : "1"}
                  onChange={(e) => handleChange(e)}
                  /* style={{ width: 150 }} */
                  style={{ width: "90%" }}
                >
                  {STATUS_VARIANTS?.map((status) => {
                    return (
                      <MenuItem key={status.id} value={status.id}>
                        {status.desc}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
              {isView && (
                <Grid item xs={8}>
                  <Typography className={classes.editSwitchOpen}>
                    Enciende para editar
                  </Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={handleEdit}
                        onChange={handleEditChange}
                        name="edit-info"
                      />
                    }
                    label="Editar"
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <RenderUpdateButton />
              </Grid>
              {(type === "edit" || type === "new") && (
                <Button
                  disabled={
                    type === "new" ? disableWhenIsNew : disableWhenIsEdit
                  }
                  className={classes.saveButton}
                  type="contained"
                  color="primary"
                  onClick={() => saveInformationHandler(currentUserInformation)}
                >
                  <Typography className={classes.updateInfoBtn}>
                    {type === "new" ? "Crear" : "Guardar"}
                  </Typography>
                </Button>
              )}
            </Grid>
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
};

export default UserinformationBodyModal;
